import { Injectable } from '@angular/core';

import * as Sentry from "@sentry/browser";

@Injectable({
  providedIn: 'root'
})

export class SentryBreadcrumbsService {

    constructor() { }

    add(category: string, message: string, data: any ) {
        Sentry.addBreadcrumb({
            category: category,
            message: message,
            data: data || {}
        });
    }
}
